import {sendServerRequest} from './baseService';

export const contentService = {
    getPages,
};

async function getPages() {
    return sendServerRequest('GET', `/api/pages`);
}
